import React from 'react';

export const FaqsPageTabContext = React.createContext({
  loading: false,
  creating: false,
  faqPage: null,
  hasFaqPage: false,
  websiteId: null,
  onCreateFaqsPage: () => null,
  onDeleteFaqsPage: () => null,
});

export const FaqsPageTabProvider = FaqsPageTabContext.Provider;

export function useFaqsPageTabContext() {
  return React.useContext(FaqsPageTabContext);
}
